import type { ShareApplicationPropertyAddress } from '../models';

export function getAddressString(propertyAddress: ShareApplicationPropertyAddress) {
  const { street, city, state, zip } = propertyAddress;
  return `${street}, ${city}, ${state} ${zip}`;
}

export function getAddressStringWithUnit(propertyAddress: ShareApplicationPropertyAddress, unit?: string) {
  const { street, city, state, zip } = propertyAddress;
  return `${street}${unit ? ` ${unit}` : ''}, ${city}, ${state} ${zip}`;
}

export function getPropertyType(propertyType: number) {
  switch (propertyType) {
    case 5:
      return 'Apartment/condo';
    case 6:
      return 'House';
    case 7:
      return 'Townhouse';
    default:
      return '';
  }
}
